import { render, staticRenderFns } from "./SoundslidesPlayer.vue?vue&type=template&id=af7ab6e4&scoped=true&lang=html&"
import script from "./SoundslidesPlayer.vue?vue&type=script&lang=js&"
export * from "./SoundslidesPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SoundslidesPlayer.vue?vue&type=style&index=0&id=af7ab6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7ab6e4",
  null
  
)

export default component.exports